var React = require('react');

function PhoneOutageIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0002 9.83333V7.83333H20.0002V9.83333H10.0002ZM8.74383 28.5C8.07027 28.5 7.50016 28.2667 7.0335 27.8C6.56683 27.3333 6.3335 26.7632 6.3335 26.0897V2.91033C6.3335 2.23678 6.56683 1.66667 7.0335 1.2C7.50016 0.733333 8.07027 0.5 8.74383 0.5H21.2565C21.9301 0.5 22.5002 0.733333 22.9668 1.2C23.4335 1.66667 23.6668 2.23678 23.6668 2.91033V26.0897C23.6668 26.7632 23.4335 27.3333 22.9668 27.8C22.5002 28.2667 21.9301 28.5 21.2565 28.5H8.74383ZM8.3335 22.8333H21.6668V6.16667H8.3335V22.8333Z","fill":"white"}));
}

PhoneOutageIcon.defaultProps = {"width":"30","height":"29","viewBox":"0 0 30 29","fill":"none"};

module.exports = PhoneOutageIcon;

PhoneOutageIcon.default = PhoneOutageIcon;
